import React, { FC, useState } from 'react';
import './index.css'

type Props = {
    label?: string;
    getFieldProps?: any;
    inputAttr?: any;
    checked?: boolean;
    disabled?: boolean;
    checkSwift?: boolean;
    options?: any;
    value?: any;
    change?: any;
    placeholder?: string;
    maxLength?: string;
    minLength?: string;
    minNumber?: number;
    rows?: number;
    maxCaracteres?: number;
    currency?: string;
    locale?: string;
    isSecure?: boolean;
    autoComplete?: string;
    name?: string;
    defaultValue?: string;
    focus?: boolean;
    smalltext?: string;
    acceptFile?: string;
    blur?: (value: string) => void;
    search?: boolean;
    textCenter?: boolean;
};


const Switch: FC<Props> = (props) => {
    const {
        disabled,
        label,
        getFieldProps,
        inputAttr,
        checked,
        options,
        value,
        change,
        placeholder,
        minLength,
        maxLength,
        checkSwift,
        minNumber,
        rows,
        maxCaracteres,
        currency,
        locale,
        isSecure = true,
        autoComplete,
        name,
        defaultValue,
        focus,
        smalltext,
        acceptFile,
        blur,
        search,
        textCenter,
    } = props;

    return (
        <div className='content'>
            <label className="switch">
                <input type="checkbox" value={value}
                    defaultChecked={checked}
                    disabled={disabled}
                    onChange={(event) => change(event.target.checked)}
                />
                <span className="slider round"></span>

            </label>
            <span>{label}</span>
        </div>
    );
};

export default Switch;